// import React from "react";
// import swal from "sweetalert";
// import { Button, Card, CardBody, Col, Row } from "reactstrap";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import {
//   useAddorUpdateReportingManagerMutation,
//   useGetAllEmployeeQuery,
// } from "./UserManagementApiSlice";
// import { useState } from "react";
// import { useEffect } from "react";
// import CustomSearchBar from "components/CustomSearchBar";

// const ReportingtoId = ({ id }) => {
//   const [getEmployeList, setEmployeeList] = useState([]);
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   const [searchKey, setSearchKey] = useState("");
//   const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });

//   const { data: data, isLoading, refetch } = useGetAllEmployeeQuery({
//     pagination,
//     searchKey,
//     stateId:"",districtId:""
//   });
//   const [
//     AddorUpdateReporting,
    
//   ] = useAddorUpdateReportingManagerMutation(selectedEmployee.id);

//   const [ReportingId, setReportingId] = useState({
//     reporting_to_id: "",
//   });

//   useEffect(() => {
//     const dataFromApi = data?.data?.results ? data?.data?.results : [];
//     const paginationFromApi = data?.data?.pages
//       ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
//       : pagination;
//     setPagination(paginationFromApi);
//     setEmployeeList(dataFromApi);
//   }, [data]);


//   const handleSelectedFle = (item) => {

//     setSelectedEmployee(item);
//     setReportingId(item);
//   };

//   const responsive = {
//     superLargeDesktop: {
//       breakpoint: { max: 4000, min: 3000 },
//       items: 5,
//     },
//     desktop: {
//       breakpoint: { max: 3000, min: 1024 },
//       items: 4,
//     },
//     tablet: {
//       breakpoint: { max: 1024, min: 464 },
//       items: 2,
//     },
//     mobile: {
//       breakpoint: { max: 464, min: 0 },
//       items: 1,
//     },
//   };

//   const handleSubmitButton = () => {
//     if (selectedEmployee == "") {
//       swal("Selection Required", {
//         buttons: false,
//         icon: "warning",
//         title: "Please Select Employee",
//         timer: 1500,
//       });
//       return;
//     }
//     let sendData = {
//       reporting_to_id: selectedEmployee.id,
//     };
//     AddorUpdateReporting({ id: id, payload: sendData })
//       .unwrap()
//       .then((data) => {
//         console.log(data, " data");

//         if (data.success) {
//           swal(".", {
//             buttons: false,
//             icon: "success",
//             title: "Reporting Manager Added SuccessFull",
//             timer: 1500,
//           });
//         }
//         refetch();
//         setTimeout(() => {
//           window.location.reload();
//         }, 2500);
//       })
//       .catch((data) => {
//         swal("Selection Required", {
//           buttons: false,
//           icon: "warning",
//           title: "Error",
//           timer: 1500,
//         });
//       });
//   };

//   const handleChangeSearch = (message) => {
   
//       setSearchKey(message);
//       refetch();
   
//   };
//   const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
//     const { carouselState: { currentSlide } } = rest;
//     return (
      
//       <div style={{position:"absolute", marginTop:"13%" ,marginLeft :"30rem"}}  > 
//        <span className="mdi mdi-chevron-left fs-3" onClick={() => previous()}></span>
//         <span onClick={() => next()} className="mdi mdi-chevron-right fs-3"></span>
       
//       </div>
      
//     );
//   };

//   return (
//     <form>
//       <Row>
//         <div className=" d-flex justify-content-between">
//           <CustomSearchBar sendSearchFunction={handleChangeSearch} />
//           <h4 className="mt-1">Total Employee :- <span className="text-success">{data?.data?.total}</span></h4>
          
//         </div>
//         {isLoading == false ? (
//           getEmployeList.length > 0 ? (
//             <Carousel
//               swipeable={true}
//               draggable={true}
//               showDots={false}
//               slidesToSlide={5}
//               responsive={responsive}
//               arrows={false}
//                customButtonGroup={<ButtonGroup />}
//               focusOnSelect={true}
//               autoPlaySpeed={1000}
//               keyBoardControl={true}
//               customTransition="all .5"
//               transitionDuration={500}
//               removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
//               className="w-100"
//             >
//               {getEmployeList.map((item, index) => {
//                 return (
//                   <Card
//                     key={index}
//                     className="mt-3 mx-2 cursor-pointer"
//                     onClick={() => handleSelectedFle(item)}
//                     style={{ backgroundColor: "#f4f4f4" ,height:"120px"}}
//                   >
//                     <CardBody className="d-flex justify-content-between align-items-center py-3 px-2 gap-3">

//                       <Col lg="2" className="w-25">
//                         <img className="w-100 rounded-circle" src={item.profile_pic} />
//                       </Col>
//                       <Col lg="6" className="w-75 d-flex justify-content-center flex-column" >
//                         <h5 className="text-success"> {item.full_name} </h5>
//                         <h6> {item.phone_number} </h6>
//                         <h6> {item.employee_code} </h6>
//                       </Col>
//                     </CardBody>
//                   </Card>
//                 );
//               })}
//             </Carousel>
//           ) : (
//             <div className="text-center mt-2 ">No Record Found</div>
//           )
//         ) : 
//           <div className="text-center mt-2 d-flex justify-content-center ">
//             <div className="spinner-grow text-warning" role="status">
//               <span className="mt-3 mx-5">Loading...</span>
//             </div>
//           </div>
//         }
//       </Row>
//       <h4 className="mt-2 mx-2">Selected</h4>
//       <Card
//         className="mt-3 mx-2 cursor-pointer col-lg-4"
//         style={{ backgroundColor: "#f4f4f4" }}
//       >
//         <CardBody className="d-flex" style={{ padding: "12px" }}>
//         {selectedEmployee != "" ? <span className="mdi mdi-close fs-6 " onClick={()=>{setSelectedEmployee("")}}></span> : ""  }
      
//           <Col lg="2" className="mt-2 mx-1">
//             <img
//               src={selectedEmployee.profile_pic}
//               width="60px"
//               height="auto"
//               className=""
//               style={{
//                 borderRadius: "50%",
//                 border: "1px solid smokewhite",
//               }}
//             />
//           </Col>
//           <Col lg="6" className="mt-2 mx-4">
//             <h5 className="">
//               <span className="text-success">{selectedEmployee.full_name}</span>
//             </h5>
//             <h6>
//               <span className="">{selectedEmployee.phone_number} </span>
//             </h6>
//             <h6 className="">
//               <span> {selectedEmployee.employee_code} </span>
//             </h6>
//           </Col>
//         </CardBody>
//       </Card>

//       <Button
//         className={`btn btn-success  me-2 px-3 custom-btn-fs `}
//         style={{ float: "right" }}
//         onClick={handleSubmitButton}
//       >
//         Submit &nbsp;
//       </Button>
//     </form>
//   );
// };

// export default ReportingtoId;

import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { DataGrid } from "@mui/x-data-grid";
import swal from "sweetalert";
import CustomSearchBar from "components/CustomSearchBar";

import {
  useAddorUpdateReportingManagerMutation,
  useGetAllEmployeeQuery,
} from "./UserManagementApiSlice";

const columns = [
  {
    field: "profile_pic",
    headerName: "",
    width: 50,
    sortable: false,
    renderCell: ({ value }) => (
      <img
        src={value}
        alt="profile"
        className="rounded-circle"
        style={{ width: 40, height: 40, objectFit: "cover" }}
      />
    ),
  },
  { field: "full_name", headerName: "Name", flex: 1, minWidth: 160 },
  { field: "phone_number", headerName: "Phone", flex: 1, minWidth: 130 },
  { field: "employee_code", headerName: "Code", flex: 1, minWidth: 110 },
];

const ReportingtoId = ({ id,handleClose }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });

  const { data, isLoading, refetch } = useGetAllEmployeeQuery({
    pagination,
    searchKey,
    stateId: "",
    districtId: "",
  });

  const [addOrUpdateReporting] = useAddorUpdateReportingManagerMutation();

  const rows = data?.data?.results ?? [];
  const totalRows = data?.data?.total ?? 0;

  const handleSearch = (msg) => {
    setSearchKey(msg);
    setPagination((prev) => ({ ...prev, page: 1 }));
    refetch();
  };

  const handleSubmit = () => {
    console.log("selectedEmployee",selectedEmployee)
    if (!selectedEmployee) {
      swal("Selection Required", {
        buttons: false,
        icon: "warning",
        title: "Please Select Employee",
        timer: 1500,
      });
      return;
    }

    addOrUpdateReporting({
      id,
      payload: { reporting_to_id: selectedEmployee.id },
    })
      .unwrap()
      .then((resp) => {
        if (resp.success) {
          swal(".", {
            buttons: false,
            icon: "success",
            title: "Reporting Manager Added Successfully",
            timer: 1500,
          });
          refetch();
          handleClose();
        }
      })
      .catch(() =>
        swal("Error", { buttons: false, icon: "error", timer: 1500 })
      );
  };

  return (
    <form className="w-100">
      <Row className="mb-3">
        <Col md="3">
          <CustomSearchBar sendSearchFunction={handleSearch} />
        </Col>
        <Col md="6" className="d-flex justify-content-end align-items-center offset-md-3">
          <h5 className="me-4">
            Total Employees:&nbsp;
            <span className="text-success">{totalRows}</span>
          </h5>
          <Button color="success" className="px-4" onClick={handleSubmit}>
            Submit
          </Button>
        </Col>
      </Row>

      {selectedEmployee && (
       <Card className="mb-3" style={{ background: "#f4f4f4" }}>
  <CardBody className="p-3">
    <h5 className="mb-3 text-dark">Selected Manager
       <span
        className="mdi mdi-close-circle-outline fs-4 text-danger cursor-pointer float-end"
        onClick={() => {
          setSelectedEmployee(null);
          setSelectedRowId(null);
        }}
      />
    </h5>
    <div className="d-flex align-items-center justify-content-between gap-3">
      <div className="d-flex align-items-center gap-2">
        <img
          src={selectedEmployee.profile_pic}
          alt="profile"
          width={40}
          height={40}
          className="rounded-circle border"
        />
        <h6 className="mb-0 text-success">{selectedEmployee.full_name}</h6>
      </div>

      <div className="text-muted">{selectedEmployee.phone_number}</div>

      <div className="text-secondary">{selectedEmployee.employee_code}</div>

     
    </div>
  </CardBody>
</Card>

      )}

      <div>
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={totalRows}
          getRowId={(row) => row.id}
          loading={isLoading}
          pageSize={50}
          paginationMode="server"
          paginationModel={{ page: pagination.page - 1, pageSize: 50 }}
          onPaginationModelChange={({ page }) =>
            setPagination((prev) => ({ ...prev, page: page + 1 }))
          }
          hideFooterSelectedRowCount
          columnVisibilityModel={{ id: false }}
          rowSelectionModel={selectedRowId ? [selectedRowId] : []}
          onRowClick={(params) => {
            console.log("params",params)
            setSelectedEmployee(params.row);
            setSelectedRowId(params.row.id);
          }}
          sx={{
            "& .MuiDataGrid-row:hover": { background: "#f9f9f9" },
            "& .MuiDataGrid-columnHeaders": { background: "#f0f0f0" },
            "& .MuiDataGrid-cellCheckbox": { display: "none" }, 
            "& .MuiDataGrid-row.Mui-selected": {
              backgroundColor: "#e0ffe0 !important",
            },
          }}
          slots={{
            baseCheckbox: () => (
              <span
                className="mdi mdi-radiobox-marked text-success fs-5"
                style={{ marginLeft: "8px" }}
              />
            ),
          }}
        />
      </div>
    </form>
  );
};

export default ReportingtoId;

